import { axios } from '@/request-clients/axios';
import { TokenProvider } from 'stream-chat';

export const getUserToken: TokenProvider = async () => {
  const res = await axios.get('clients/chat/token');
  return res.data?.token;
};
